import moment from 'moment';

const getPromoListResponse = (response) => {
  return {
    ...response,
    lastSync: moment(new Date(response.lastSync)).format('DD/MM/YYYY, HH:mm:ss'),
  };
};

export default getPromoListResponse;
